import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const LabelSets = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { LabelSets, defaultState };
